<script setup lang="ts">
import { nextTick, onMounted, ref, watch } from 'vue'
import { Menu } from '../../../types/auth';
import { useRoute } from 'vue-router';
import { tokenManager } from '../../../api/utils/tokenManager';
import SideMenuList from './SideMenuList.vue';
import CategoryButton from '../navigation/CategoryButton.vue';
import VerticalMegaMenu from '../navigation/VerticalMegaMenu.vue';

const props = defineProps<{
  isMobileOpen?: boolean
}>()


const activeMenus = ref<Menu[]>()
const activeCategory = ref<Menu>()
const isMinimized = ref(false)

const megaMenu = ref<Menu[]>()

const isWelcome = ref(false)
const categories = ref<Menu[]>([])

const route = useRoute();

onMounted(() => {
  isWelcome.value = route.path === '/welcome' || route.path === 'welocome'
  isMinimized.value = isWelcome.value
  const v = tokenManager.getMenu()
  if (v) {
    const cat = v.filter((o) =>
      Object.keys(o).some(() =>
        o['modules_id'] == null
      )
    ) || [];
    categories.value = cat
    toggleCategory(cat[0])

    let cats = v.filter((o) =>
      Object.keys(o).some(() =>
        o['modules_id'] == null
      )
    );
    cats.forEach(c => {
      let cat_menu = v.filter((o) =>
        Object.keys(o).some(() =>
          o['modules_id'] == c.id
        )
      );
      cat_menu.forEach(n => {
        let mnu = v.filter((o) =>
          Object.keys(o).some(() =>
            o['modules_id'] == n.id
          )
        );
        n.sub_menus = mnu
      });
      c.sub_menus = cat_menu
    });
    megaMenu.value = cats
  }

    let storedMinimizedState = tokenManager.getSideBarStatus()
    
  nextTick(() => {
    if (storedMinimizedState == true) {
      toggleSidebar()
    }
  });
  
 
})

const toggleCategory = (menu: Menu) => {
  const v = tokenManager.getMenu()
  const cat_menu = v?.filter((o) =>
    Object.keys(o).some(() =>
      o['modules_id'] == menu.id
    )
  );
  cat_menu?.forEach(cat => {
    cat.sub_menus = (v || []).filter((o) =>
      Object.keys(o).some(() =>
        o['modules_id'] == cat.id
      )
    );
  });
  activeMenus.value = cat_menu
}

const toggleSidebar = () => {
  isMinimized.value = !isMinimized.value
  emit('toggle', isWelcome.value, isMinimized.value)
  tokenManager.setSideBarStatus(isMinimized.value)
}

// Close mobile menu when clicking outside
const handleOutsideClick = (event: MouseEvent) => {
  if (props.isMobileOpen && !(event.target as Element).closest('aside')) {
    emit('update:isMobileOpen', false)
  }
}

// Watch for mobile menu changes
watch(() => props.isMobileOpen, (newVal) => {
  if (newVal) {
    document.addEventListener('click', handleOutsideClick)
  } else {
    document.removeEventListener('click', handleOutsideClick)
  }
})

watch(() => route.path, () => {
  isWelcome.value = route.path === '/welcome' || route.path === 'welocome'
  if (isWelcome.value == true)
    toggleSidebar()
})


const emit = defineEmits<{
  (e: 'update:isMobileOpen', value: boolean): void
  (e: "toggle", welcome: boolean, minimized: boolean): void;
}>()
</script>

<template>
  <div>
  <aside 
    class="bg-white dark:bg-black border-r border-gray-100 dark:border-gray-800 fixed left-0 top-0 h-screen transition-all duration-300 z-40 flex flex-col"
    :class="[
      isMinimized ? 'w-16' : 'w-64',
      isMobileOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
    ]"
  >
    <div v-if="isWelcome" class="absolute inset-0 bg-black bg-opacity-50 z-50"></div>
  >
    <!-- Top spacing for header -->
    <div class="h-16"></div>

    <button 
      @click="toggleSidebar"
      class="absolute right-4 top-20 -right-3 w-8 h-8 hidden md:flex items-center justify-center bg-gray-50 dark:bg-gray-900 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 border border-gray-100 dark:border-gray-800 shadow-sm"
    >
      <span class="text-sm text-gray-600 dark:text-gray-400">
        {{ isMinimized ? '→' : '←' }}
      </span>
    </button>

    <!-- Main content area with flex-grow -->
    <div class="flex-1 flex flex-col min-h-0" v-if="!isMinimized">
      <!-- Scrollable menu area -->
      <div class="flex-1 overflow-y-auto">
        <template v-if="!isMobileOpen">          
          <SideMenuList :menu="activeMenus" />
        </template>
        
      </div>
    </div>

    <!-- Fixed category buttons at bottom -->
    <div>
      <div class="p-2">
        <div v-if="!isMinimized" class="grid grid-cols-3 gap-0.5">
          <CategoryButton
            v-for="category in categories" 
            :key="category.uid"
            :label="category.name"
            :icon="category.icon_css"
            :active="activeCategory?.name === category.name"
            @click="toggleCategory(category)"
          />
        </div>
        <div v-else class="flex flex-col mt-3">
          <div class="flex flex-col space-y-1">
            <VerticalMegaMenu />
            </div>
        </div>
      </div>
    </div>
  </aside>

  <!-- Mobile overlay -->
  <div 
    v-if="isMobileOpen"
    class="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
    @click="$emit('update:isMobileOpen', false)"
  ></div>
</div>
</template>